import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom"; // <-- 1. Import useNavigate
import axios from "../../api/axios";
import "./Team.css";

const Team = () => {
  const [members, setMembers] = useState([]);
  const navigate = useNavigate(); // <-- 2. Initialize useNavigate

  useEffect(() => {
    fetchMembers();
  }, []);

  const fetchMembers = async () => {
    try {
      const res = await axios.get("/team");
      // Show first uploaded → first (left-to-right, top-to-bottom)
      setMembers(res.data.reverse());
    } catch (err) {
      console.error("Error fetching team members:", err);
    }
  };

  // 3. Define the navigation handler
  const handleViewFullTeam = () => {
    navigate("/ourteam");
  };

  return (
    <section className="team-section" id="team">
      <h2 className="team-heading">
        <span className="highlight">MEET OUR TEAM</span>
      </h2>

      <div className="team-grid">
        {members.map((member) => (
          <div className="team-card" key={member.id}>
            <div className="team-photo-wrapper">
              <img
                src={`https://blog.dietchapter.hosting.acm.org//${member.imagePath}`}
                alt={member.name}
                className="team-photo"
              />
            </div>
            <div className="team-info">
              <h3>{member.name}</h3>
              <p className="team-role">{member.title}</p>
              {/* DESCRIPTION REMOVED HERE */}
            </div>
          </div>
        ))}
      </div>

      <div className="view-full">
        {/* 4. Attach the handler to the button */}
        <button 
          className="view-full-btn"
          onClick={handleViewFullTeam}
        >
          View Full Team
        </button>
      </div>
    </section>
  );
};

export default Team;